module.exports = function init_wpdt() {

  // wait for wpdt to initialize
  setTimeout(function() {

    // target any table within the #order-hx-table-container element
    const table_selector = '#order-hx-table-container table';
    const table_element = document.querySelector(table_selector);
    
    if (!table_element) {
      return;
    }
    
    const table_id = table_element.id;
    
    if (table_id && typeof wpDataTables[table_id] !== 'undefined') {
      
      // add callback for when the table is drawn (initial draw & filtering)
      wpDataTables[table_id].addOnDrawCallback(function() {
        process_all_rows(table_id);
      });
      
      // initial styling
      process_all_rows(table_id);
    } 
  }, 1000);

  function process_all_rows(table_id) {

    const order_id_column_index = 3;

    // get table API
    const table_api = wpDataTables[table_id].api();

    // first, reset all rows to default state
    // this gets ALL rows, not just filtered ones
    const all_nodes = table_api.rows().nodes();
    for (let i = 0; i < all_nodes.length; i++) {
      const row = all_nodes[i];
      row.classList.remove('submission-row-even', 'submission-row-odd', 'submission-first-row', 'submission-child-row');

      const first_cell = row.querySelector('td:first-child');
      if (first_cell) {
        first_cell.classList.remove('submission-hidden-cell');
      }
    }

    // group visible/filtered rows by order_id
    const order_groups = {};
    table_api.rows({order: 'current', search: 'applied'}).every(function() {
      const order_id = String(this.data()[order_id_column_index]);
      if (!order_groups[order_id]) {
        order_groups[order_id] = [];
      }
      order_groups[order_id].push(this.node());
    });

    // apply styling to each group
    let group_count = 0;
    for (const order_id in order_groups) {
      group_count++;
      const nodes = order_groups[order_id];
      const row_class = group_count % 2 === 0 ? 'submission-row-even' : 'submission-row-odd';

      for (let i = 0; i < nodes.length; i++) {
        const row = nodes[i];
        row.classList.add(row_class);

        if (i === 0) {
          row.classList.add('submission-first-row');
        } else {
          row.classList.add('submission-child-row');
          const first_cell = row.querySelector('td:first-child');
          if (first_cell) {
            first_cell.classList.add('submission-hidden-cell');
          }
        }
      }
    }
  }
};